// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__1APmU","row":"Node_row__2No7q","label":"Node_label__2n0_F","footer":"Node_footer__3WLoL"};